import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_RECIBOS,
  ESTADISTICAS_RECIBOS,
  ALL_RECIBOS,
  LOADING_ALL_RECIBOS,
} from './RecibosReducer';
import {
  deleteRecibosService,
  estadisticasRecibosService,
  allRecibosService,
  oneRecibosService,
  saveRecibosService,
  updateEstatusRecibosService,
} from './RecibosService';

export const allRecibosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_RECIBOS, payload: true });
    const res = await allRecibosService(params);
    dispatch({ type: ALL_RECIBOS, payload: res.data });
    dispatch({ type: LOADING_ALL_RECIBOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_RECIBOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveRecibosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveRecibosService(id, data);
    notify(res.data.message);
    await allRecibosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoRecibosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_RECIBOS, payload: data });
};

export const oneRecibosAction = async (dispatch, idEntidad, id) => {
  try {
    const res = await oneRecibosService(idEntidad, id);
    await setActivoRecibosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteRecibosAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteRecibosService(id);
    notify(res.data.message);
    await setActivoRecibosAction(dispatch, null);
    await allRecibosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const updateEstatusRecibosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await updateEstatusRecibosService(id, data);
    notify(res.data.message);
    await allRecibosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const estadisticasRecibosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_RECIBOS, payload: true });
    const res = await estadisticasRecibosService(params);
    dispatch({ type: ESTADISTICAS_RECIBOS, payload: res.data.data });
    dispatch({ type: LOADING_ALL_RECIBOS, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_RECIBOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};
